var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "goal-container" },
    [
      _c(
        "callout",
        {
          staticClass: "goal-list",
          attrs: {
            controlled: true,
            "has-border": false,
            "has-gradient": "",
            "has-toggle": _vm.hasToggle,
            opened: _vm.isCalloutOpen
          },
          on: { "click:open": () => (_vm.isCalloutOpen = !_vm.isCalloutOpen) },
          scopedSlots: _vm._u([
            {
              key: "edition",
              fn: function() {
                return [
                  _vm.showAreaSelection
                    ? _c(
                        "div",
                        { staticClass: "col-12 col-md-10" },
                        [
                          _c("SelectedGoalsAreas", {
                            attrs: {
                              readonly: true,
                              "selected-goals": _vm.goal
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("intervention-plan-objetives", {
                    attrs: {
                      "achievement-summary": _vm.achievementSummary,
                      "add-objetive": _vm.addObjetive,
                      data: _vm.goal.objectives,
                      "goal-number": _vm.position,
                      "legend-data": _vm.legendData,
                      measurement: _vm.measureCodes,
                      "read-only": _vm.readOnly,
                      "submitted-summaries": _vm.submittedSummaries,
                      "summary-read-only": _vm.summaryReadOnly
                    },
                    on: {
                      "cancel-add": _vm.cancelObjHandler,
                      "delete-objetive": _vm.deleteObjetiveHandler,
                      "edit-objetive": _vm.editObjetiveHandler,
                      "save-objetive": _vm.saveObjetiveHandler
                    }
                  })
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("div", { staticClass: "row align-items-center" }, [
            _c(
              "div",
              {
                staticClass: "col-12 col-md-10 pl-0 py-2",
                class: { "pl-3 pl-md-0": _vm.goal.objectives.length == 0 }
              },
              [
                _c("span", { staticClass: "gray-chip" }, [
                  _vm._v("Meta #" + _vm._s(_vm.position))
                ]),
                _c("p", { staticClass: "text-format mt-2 pl-1" }, [
                  _vm._v(_vm._s(_vm.goal.description))
                ])
              ]
            ),
            !_vm.readOnly
              ? _c(
                  "div",
                  {
                    staticClass: "col-12 col-md-2 pl-0 ml-md-n1 text-right",
                    class: _vm.goal.objectives.length != 0 ? "ml-n3" : "ml-1"
                  },
                  [
                    _c("drop-down", {
                      staticClass: "goals-action",
                      attrs: { items: _vm.actionItems }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ]
      ),
      !_vm.readOnly
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-end" },
            [
              _c("action-button", {
                attrs: {
                  i: "fas fa-file-plus",
                  responsive: "",
                  text: "Añadir Objetivo",
                  variant: "success"
                },
                on: {
                  click: function($event) {
                    return _vm.addObjetives()
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }